export default "__VITE_ASSET__10e2fd7b__"